import { PaginationMeta } from 'common/repositories/common.model';
import TableComponent, {
  IColumn,
  TableComponentProps,
} from 'components/elements/table-component/table-component';
import React from 'react';

export interface UniskaiTableProps<T> extends TableComponentProps<T> {
  meta?: PaginationMeta;
}

export default function UniskaiTable<T>(props: UniskaiTableProps<T>) {
  const { columns: _columns, meta, ...rest } = props;

  const columns = React.useMemo<IColumn<any>[]>(() => {
    if (meta) {
      return [
        {
          header: '#',
          accessorKey: 'index',
          stickyLeft: true,
          minSize: 40,
          maxSize: 40,
          cell: ({ row }) => {
            return (
              <>
                {row.index +
                  1 +
                  ((meta?.currentPage || 1) - 1) * (meta?.perPage || 1)}
              </>
            );
          },
        },
        ..._columns,
      ];
    }

    return _columns;
  }, [_columns, meta]);

  return (
    <>
      <div style={{ flex: 1, overflowY: 'auto', overflowX: 'scroll' }}>
        <TableComponent
          {...rest}
          columns={columns.filter((item) => item.isHidden !== true)}
          isShowRawTable
        />
      </div>
    </>
  );
}
